import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import BreadCrumbComponent from '@components/obsolete/BreadCrumbComponent/BreadCrumbComponent.tsx';
import Heading from '@components/ringil3/Heading/Heading';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser';
import { PermissionTypesEnum } from '@api/ringil-api.v2';
import AiDispatcherRules from '@components/features/ai-dispatcher/AiDispatcherRules';

interface ComponentProps {
  /** Set by the admin route, which picks the company from the row it was opened from. */
  companyId?: string;
}

/**
 * The company's own AI-dispatcher rules.
 *
 * The editor is company-agnostic and takes `companyId` as a prop, so the admin section can reuse
 * it unchanged once the admin endpoints exist — only the surrounding page and the data source
 * differ.
 */
const AiDispatcherSettings: React.FC<ComponentProps> = ({ companyId }) => {
  const { tr } = useTranslationLgs();
  const { hasPermission } = useContext(AuthenticatedUserContext);
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  const readOnly = !hasPermission([PermissionTypesEnum.PERMISSION_AI_DISPATCHER_RW]);

  return (
    <>
      {!isMobile && <BreadCrumbComponent items={[{ label: tr('AiDispatcher.breadCrumb', 'AI dispatcher') }]} />}
      <Heading title={tr('AiDispatcher.pageTitle', 'AI dispatcher rules')} headingVariant="h1" />
      <AiDispatcherRules companyId={companyId} readOnly={readOnly} />
    </>
  );
};

export default AiDispatcherSettings;
